export class RegisterSurfboardTerminalResponseDto {
  surfboardTerminalId: string
}